import(/* webpackMode: "eager" */ "/codebuild/output/src3690189694/src/doctor-dashboard/src/components/loader/AppLoader.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3690189694/src/doctor-dashboard/src/components/loader/SplashScreenLoader.tsx");
